/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import { useSelector } from "react-redux";
import BASEScrollbars from "../BASEScrollbars";
import { ThemeProvider, useTheme } from "@mui/material/styles";
import { selectContrastMainTheme } from "../../../app/store/BASE/settingsSlice";
import clsx from "clsx";

function BASEPageSimpleSidebarContent(props) {
  const theme = useTheme();
  const contrastTheme = useSelector(
    selectContrastMainTheme(theme.palette.primary.main)
  );

  return (
    <BASEScrollbars enable={props.innerScroll}>
      {props.header && (
        <ThemeProvider theme={contrastTheme}>
          <div className={clsx("BASEPageSimple-sidebarHeader", props.variant)}>
            {props.header}
          </div>
        </ThemeProvider>
      )}

      {props.content && (
        <div className="BASEPageSimple-sidebarContent min-w-320 lg:min-w-0">{props.content}</div>
      )}
    </BASEScrollbars>
  );
}

export default BASEPageSimpleSidebarContent;
